var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.picture)?_c('figure',{staticClass:"avatar"},[_c('img',{attrs:{"src":_vm.picture,"width":"50","height":"50"}})]):_c('figure',{staticClass:"avatar letter-avatar"},[_c('span',[_vm._v(_vm._s((_vm.user.first_name || _vm.user.email)[0] || '-'))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f7b7b5c4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserPictureUI.vue
// module id = null
// module chunks = 